import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import './slide-4.less';


export const Slide4 = ({
}) => (
    <div className="trip-board-onboarding-slide4">
        <div className="trip-board-onboarding-slide4__gray-circle" />
        <div className="trip-board-onboarding-slide4__house1" />
        <div className="trip-board-onboarding-slide4__white-pill1">
            <div className="trip-board-onboarding-slide4__person1"/>
            <div className="trip-board-onboarding-slide4__commnent1">
                <FormattedHTMLMessage id={'tripboards.main.empty.comment1'} defaultMessage={''} description="Trip Board comment 1"/>
                {' 😃'}
            </div>
        </div>
        <div className="trip-board-onboarding-slide4__white-pill2">
            <div className="trip-board-onboarding-slide4__person2"/>
            <div className="trip-board-onboarding-slide4__commnent2">
                <FormattedHTMLMessage id={'tripboards.main.empty.comment2'} defaultMessage={''} description="Trip Board comment 2"/>
            </div>
        </div>
    </div>
);

export default Slide4;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/content/static/slide-4/slide-4.js